import { useState } from 'react'
import { FileUpload } from '@/components/FileUpload'
import { FileList } from '@/components/FileList'
import { FileShareDialog } from '@/components/FileShareDialog'
import { useAuth } from '@/hooks/useAuth'

export function FilesPage() {
	const { user } = useAuth()
	const [shareFileId, setShareFileId] = useState<string | null>(null)

	return (
		<div className="space-y-8">
			<div>
				<h1 className="text-2xl font-bold text-gray-900">Files</h1>
				<p className="mt-1 text-sm text-gray-500">Upload, manage, and share files</p>
			</div>

			<FileUpload />

			<FileList currentUserId={user?.userId} currentUserRole={user?.role} />

			{shareFileId && <FileShareDialog fileId={shareFileId} onClose={() => setShareFileId(null)} />}
		</div>
	)
}
